module.exports = require('./ConsumerDiscountApplicationView');
